module.exports = require('./ConsumerDiscountApplicationView');
